{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Výběr barvy",
  "twoDimensionalSlider": "2D posuvník"
}
